import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { formatThousands } from "@/utils/index.js";
import UploadFile from "@/views/quarter/components/UploadFile.vue";
import util from "@/libs/util";
import SourceTag from "@/views/quarter/components/SourceTag.vue";
export default {
  name: 'InvoiceForm',
  components: {
    SourceTag: SourceTag,
    UploadFile: UploadFile
  },
  props: {
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: [String, Number],
      default: 250
    },
    placement: {
      type: String,
      default: 'top'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      rules: {
        slip: [{
          required: true,
          message: '请上传发票PDF',
          trigger: 'change'
        }]
      },
      form: {
        slip: ''
      },
      loading: false,
      adminId: util.cookies.get("uuid") || "",
      isEdit: false
    };
  },
  methods: {
    formatThousands: formatThousands,
    show: function show(row, isEdit) {
      this.form = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(row))), this.form);
      if (this.form.status === "6") {
        this.form.slip = this.form.bill;
      }
      this.isEdit = isEdit;
      this.visible = true;
    },
    cancel: function cancel() {
      var _this = this;
      this.visible = false;
      this.$emit('cancel');
      this.$nextTick(function () {
        _this.$refs['ruleForm'].resetFields();
        _this.form = {
          slip: ''
        };
      });
    },
    save: function save() {
      var _this2 = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var fun = _this2.form.status === "3" ? "bankConfirmProcess" : "bankEditInvoice";
          var params = {
            transactionNo: _this2.form.receiptWaterNbr,
            status: "6",
            adminId: _this2.adminId
          };
          if (_this2.form.status === "6") {
            params.slip = _this2.form.slip;
          } else {
            params.invoice = _this2.form.slip;
          }
          _this2.$api[fun](params).then(function (res) {
            if (res.code === 200) {
              _this2.$message.success(_this2.form.status === "3" ? "确认开票成功！" : "开票信息已修改");
              _this2.$operationLog.push({
                code: _this2.form.status === "3" ? 'confirm_invoice' : 'edit_invoice',
                operationType: 'payment',
                detailBatchNo: _this2.form.receiptWaterNbr
              });
            }
            _this2.$emit('confirm', _this2.form);
            _this2.visible = false;
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};